'use es6';

import { Record } from 'immutable';
import { FIFTEEN_MINUTE_DURATION } from 'MeetingsBase/constants/dates';
export default Record({
  duration: FIFTEEN_MINUTE_DURATION,
  formFields: null,
  dateString: null,
  dateTime: null,
  bookingTimeConflictStatus: false
}, 'Event');